import React, { useMemo } from "react";
import { TableCompData } from "../../../../../components";
import EmptyTable from "../../../../../components/Common/EmptyTable";
import { AdminWithdrawalRequestsHeader } from "../../../../../utils/TableHeader";
import TablePagination from "../../../../../components/Table/Pagination";
import TableSkeletonLoader from "../../../../../components/Common/TableSkeletonLoader";
import { useGetWithdrawalRequestsQuery } from "../../../../../store/admin/contribution";

export default function ApprovedRequestsTab({
  page,
  setPage,
  onMarkAsPaid,
  onViewDetails,
}) {
  const { data, isFetching } = useGetWithdrawalRequestsQuery({
    status: "approved",
    page,
    limit: 20,
  });

  const tableData = useMemo(() => {
    if (!data?.withdrawal_requests) return [];

    return data.withdrawal_requests.map((request) => ({
      ...request,
      serialNumber: request.id,
    }));
  }, [data]);

  const pagination = data?.pagination || {};

  const actionHandlers = {
    onViewDetails,
    onMarkAsPaid,
  };

  return (
    <div>
      <TableCompData
        marginBottom={"72px"}
        columns={AdminWithdrawalRequestsHeader(actionHandlers)}
        data={tableData}
        progressPending={isFetching}
        progressComponent={<TableSkeletonLoader rows={10} columns={7} />}
        message={
          !isFetching && (
            <EmptyTable Message="There are currently no approved withdrawal requests" />
          )
        }
        cellPadding="12px"
      />
      {!isFetching && tableData?.length > 0 && (
        <TablePagination
          marginTop={"0"}
          handlePageChange={setPage}
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          total={pagination.total}
          count={pagination.count}
          perPage={pagination.perPage}
        />
      )}
    </div>
  );
}

